import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";

function About() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      <div className="inner-section-1">
        <div className="wrapper">
          <div className="inner-section-1-1">
            <h2 data-aos="zoom-in">
              Engineering the Next Generation of Climate Intelligence
            </h2>
            <p data-aos="fade-down">
              At Accel1, we are not just another tech company—we are architects
              of environmental transformation.
            </p>
            <p data-aos="fade-down">
              We’re building a next-generation technology platform designed to
              tackle the most urgent planetary issues—climate volatility, water
              insecurity, ecosystem degradation, and carbon-intensive industrial
              systems. Our mission is bold: to engineer planet-scale resilience
              using the power of deep technology, integrated intelligence, and
              regenerative thinking.
            </p>
            <p data-aos="fade-down">
              Founded by leaders from government, enterprise tech, and global
              innovation ecosystems, Accel1 is where systems science meets
              software, and climate pragmatism meets technological audacity.
            </p>
          </div>
        </div>
      </div>

      <div className="our-philosophy-bg-1">
        <div className="wrapper height-inherit">
          <div class="flagship-heading" data-aos="zoom-in">
            <h2>Our Philosophy</h2>
            <p>Don’t optimize the system. Rebuild it.</p>
          </div>

          <div className="section-2-2" data-aos="fade-up">
            <p>
              The environmental crisis is not a data problem—it’s a systems
              failure. At Accel1, we’re not just adding dashboards or improving
              processes. We’re reimagining how governments, corporations, and
              communities interact with the Earth’s critical systems—from water
              cycles and soil health to atmospheric dynamics and sustainable
              commerce.
            </p>
            <p>
              We believe in solving problems at the infrastructure layer, not
              the interface. We’re building platforms and capabilities that can
              adapt, learn, and scale, not just measure.
            </p>
          </div>
        </div>
      </div>
      <div className="ethos-bg">
        <div className="wrapper">
          <h2>The Accel1 Ethos</h2>

          <div className="ethos-wrap">
            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.PurposeLed} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <h4>Purpose-Led</h4>
                <p>
                  We exist to serve life-centered innovation — where nature is
                  not an afterthought but the core operating system. Every
                  product we build is designed to accelerate ecological and
                  social value.
                </p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.PlatformThinking} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <h4>Platform Thinking</h4>
                <p>
                  Our architecture isn’t tool-based—it’s platform-based. Accel1
                  is building interoperable systems that connect environmental,
                  industrial, and socio-economic data in real-time for
                  coordinated climate action.
                </p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.ScienceDriven} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <h4>Science-Driven</h4>
                <p>
                  Our approach is grounded in climate science, systems
                  engineering, and data ethics. We partner with leading
                  scientists, universities, and field researchers to ensure our
                  models and interventions are rigorously validated and locally
                  relevant.
                </p>
              </div>
            </div>

            <div className="ethos-card">
              <div className="ethos-1" data-aos="zoom-in">
                <img src={assets.ExecutionObsessed} alt="" />
              </div>
              <div className="ethos-2" data-aos="zoom-in">
                <h4>Execution Obsessed</h4>
                <p>
                  We ship fast. We scale faster. And we stay grounded. Our team
                  comes from enterprise, start-up, and public sector
                  backgrounds—meaning we know how to build, integrate, and
                  deliver where it counts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="building-section-1">
        <div className="wrapper height-inherit">
          <div class="building-section-2-1">
            <h2>What We’re Building (Beyond Tools)</h2>
            <p>
              While our platforms power real-time monitoring, predictive
              analytics, and ESG compliance—they’re ultimately designed to do
              much more:
            </p>
          </div>

          <div className="building-section-2-2">
            <div className="building-list">
              <ul>
                <li>
                  Rebuild trust between governments and citizens through
                  transparent climate governance
                </li>
                <li>
                  Help industries decarbonize without losing competitive edge
                </li>
                <li>Turn local climate data into public good infrastructure</li>
                <li>
                  Empower the next generation of climate professionals with
                  systems-level tools
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="ecosystem-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Our Ecosystem Approach</h2>
            <p>
              We believe climate cannot be solved in silos. That’s why we
              actively co-create with:
            </p>
          </div>
          <img src={assets.aproch} alt="VisionImpactImg" data-aos="zoom-in" />
        </div>
      </div>
      <div className="about-bg-3">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="green-color">Why Now?</h2>
            <p>
              Because the climate crisis has a clock—and we’ve already hit
              snooze too many times. Our planet needs bold, systemic, and agile
              responses—not someday, but today.
            </p>
            <p>
              We’re here to build that response—through platforms that work,
              systems that scale, and partnerships that move the needle.
            </p>
          </div>
        </div>
      </div>

      <div className="about-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Who We Are</h2>
            <p>
              Accel1 is a collective of engineers, scientists, strategists,
              ex-bureaucrats, entrepreneurs, designers, and doers. We’ve built
              billion-dollar platforms, shaped national climate strategies, and
              transformed operations across sectors. Now, we’ve come together to
              build a purpose company for a regenerative future.
            </p>

            <Link
              to="/company/leadership"
              className="button-1"
              onClick={scrollToTop}
            >
              Meet our Team
            </Link>

            <div className="line-1"></div>
            <h2>Let’s Build the Future, Together</h2>
            <p>
              Whether you’re a public leader, private investor, startup
              innovator, or field practitioner—we want to hear from you. The
              future will not be won with silos, but with systems.
            </p>
            <p>Welcome to Accel1. Let’s accelerate what matters.</p>
          </div>
        </div>
      </div>
      {/* <div className="section-1" style={sectionStyle}>
        <img src={assets.banner1} alt="" data-aos="fade-up" />
      </div> */}
    </div>
  );
}

export default About;
